import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Icon from '../common/Icons';
import useConsultationRecentHistory from './hooks/useConsultationRecentHistory';
import { formatAppDate } from '../../utils/appTimezone';
import './ConsultationEditorHeaderHistory.css';

function formatConsultDate(value) {
  if (!value) return '—';
  return formatAppDate(value, {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}

function statusLabel(status) {
  if (status === 'COMPLETED') return 'Terminée';
  if (status === 'PENDING') return 'En cours';
  if (status === 'CANCELLED') return 'Annulée';
  return status || '—';
}

function statusClass(status) {
  if (status === 'COMPLETED') return 'consult-editor-history__status--done';
  if (status === 'PENDING') return 'consult-editor-history__status--pending';
  if (status === 'CANCELLED') return 'consult-editor-history__status--cancelled';
  return '';
}

function previewLine(item) {
  const text = item.symptoms || item.diagnosis || item.notes || '';
  const trimmed = String(text).trim();
  if (!trimmed) return 'Sans compte rendu';
  return trimmed.length > 72 ? `${trimmed.slice(0, 72)}…` : trimmed;
}

export default function ConsultationEditorHeaderHistory({
  consultation,
  workSiteId,
  buildEditPath,
  limit = 5,
  refreshKey = 0
}) {
  const navigate = useNavigate();
  const { items, loading } = useConsultationRecentHistory(consultation, workSiteId, limit, refreshKey);

  return (
    <aside className="consult-editor-history" aria-label="Historique récent du patient">
      <div className="consult-editor-history__head">
        <Icon name="history" size={15} className="consult-editor-history__head-icon" aria-hidden />
        <div>
          <h2 className="consult-editor-history__title">{limit} derniers passages</h2>
          <p className="consult-editor-history__hint mb-0">Consultations antérieures du patient</p>
        </div>
      </div>

      {loading ? (
        <div className="consult-editor-history__loading" role="status" aria-live="polite">
          <Spinner animation="border" size="sm" />
          <span>Chargement…</span>
        </div>
      ) : items.length === 0 ? (
        <p className="consult-editor-history__empty mb-0">Aucun antécédent récent.</p>
      ) : (
        <ul className="consult-editor-history__list">
          {items.map((item) => (
            <li key={item.id}>
              <button
                type="button"
                className="consult-editor-history__item"
                onClick={() => navigate(buildEditPath(item.id))}
              >
                <span className="consult-editor-history__item-top">
                  <span className="consult-editor-history__date">{formatConsultDate(item.consultation_date)}</span>
                  <span className={`consult-editor-history__status ${statusClass(item.status)}`}>
                    {statusLabel(item.status)}
                  </span>
                </span>
                <span className="consult-editor-history__ref">#{item.id}</span>
                <span className="consult-editor-history__preview">{previewLine(item)}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </aside>
  );
}
